import { isLongFormContentImproverTool } from 'src/data/generationTool';

import { LONG_FORM_DRAFT_STATUS, LONG_FORM_ORIGINAL_DRAFT_INDEX } from './const';

export const getProjectLongFormGenerationTool = (project) =>
  project?.longFormBuilderProject?.generationTool;

export const getProjectLongFormEditingDrafts = (project) => {
  const tool = getProjectLongFormGenerationTool(project);

  return onlyEditingLongFormDrafts(project?.longFormBuilderDrafts, {
    // we don't want "original" draft to be displayed for "content improver" long-form project
    skipImproverOriginal: isLongFormContentImproverTool(tool),
  });
};

/**
 * Returns only drafts that are in editing status. Sorts them by "draftId".
 *
 * @param {Object[]} drafts
 * @param {Object} [options]
 * @param {boolean} [options.skipImproverOriginal] - If true, skips the "original" draft for "content improver" tool.
 * @returns {Object[]}
 */
export const onlyEditingLongFormDrafts = (drafts, options = null) => {
  if (!drafts || !Array.isArray(drafts)) {
    return [];
  }

  const list = drafts
    .filter((draft) => draft.status === LONG_FORM_DRAFT_STATUS.editing)
    .sort((a, b) => a.draftId - b.draftId);

  if (options?.skipImproverOriginal) {
    return list.filter((draft) => draft.draftId !== LONG_FORM_ORIGINAL_DRAFT_INDEX);
  }

  return list;
};
